import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { colorSecondary200 } from 'app/style/colors';
import { spacing1, spacing2, spacing3 } from 'app/style/spacing';

export const StyledTitle = styled(Typography)`
    font-weight: bold;
    margin-bottom: ${spacing3};
`;

export const StyledText = styled(Typography)`
    flex-basis: 50%;
    text-align: right;
`;

export const StyledOrderDetails = styled.div`
    margin: ${spacing3} 0;
    border-bottom: 1px solid ${colorSecondary200};
    padding-bottom: ${spacing2};
`;

export const StyledDetailsRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: ${spacing1} 0;
`;

export const StyledProductTitle = styled(Typography)`
    font-weight: bold;
    text-align: left;
    margin-right: ${spacing2};
`;

export const StyledDetailsTitle = styled(StyledProductTitle)`
    flex-basis: 50%;
`;

export const StyledProductText = styled(Typography)`
    font-weight: bold;
    text-align: right;
`;

export const StyledProducts = styled.div`
    display: grid;
    grid-column-gap: ${spacing1};
    text-align: left;
    grid-template-rows: repeat(2, auto);
    grid-template-columns: repeat(2, auto);
`;
